
import { Component, Vue } from 'vue-property-decorator';
import config from '@/config';

@Component({
  name: 'RGPDStarApp',
})
export default class RGPDStarApp extends Vue {
  mounted() {
    // Redirect to home page if the app name is not star
    const name = config.nameApp || '';
    if (name.toLowerCase() !== 'star') {
      this.$router.push({ path: '/' });
    }
  }
}
